import React, { useState } from "react";
import LightningTipModal from "./LightningTipModal";

const BMAC_URL = "https://buymeacoffee.com/xaelserpent";
const BTC_ADDRESS = "1Xaya5XhGqX7d7pjtcXCgPUz8jsjhd3t1";
const MEMPOOL_URL = `https://mempool.space/address/${BTC_ADDRESS}`;
const LN_ADDRESS = "xaelserpent@coinos.io";

/**
 * Donation widget — Buy Me A Coffee + Bitcoin on-chain + Lightning (pay with sats).
 * Designed to appear at the bottom of every article to convert blockchain-timestamped
 * credibility into repeat-visitor revenue.
 */
export default function DonationWidget({ post }) {
  const [copied, setCopied] = useState("");
  const [tipOpen, setTipOpen] = useState(false);
  const copy = async (val, label) => {
    try {
      await navigator.clipboard.writeText(val);
      setCopied(label);
      setTimeout(() => setCopied(""), 1800);
    } catch {}
  };

  return (
    <section
      data-testid="donation-widget"
      style={{
        marginTop: 40,
        border: "1px solid #ffde16",
        borderRadius: 10,
        padding: 20,
        background: "rgba(255, 222, 22, 0.05)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 8 }}>
        <span style={{ fontSize: "1.4em" }}><img src="/" alt="" className="inline-block h-4 w-4 align-middle" /></span>
        <h3 style={{ margin: 0, color: "#ffde16", letterSpacing: 1 }}>
          support the work
        </h3>
      </div>
      <p style={{ color: "#fffbd4", fontSize: "0.92em", lineHeight: 1.6, margin: "6px 0 16px" }}>
        this post is blockchain-timestamped, ad-supported, and creator-owned. if it hit,
        drop a tip — coffee, sats, or on-chain. every bit keeps the lights on.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
        {/* Buy Me a Coffee */}
        <a
          href={BMAC_URL}
          target="_blank"
          rel="noreferrer"
          className="xs-btn primary"
          data-testid="donate-bmac"
          style={{ justifyContent: "center" }}
        >
          ☕ buy me a coffee
        </a>

        {/* Lightning */}
        <button
          type="button"
          className="xs-btn primary"
          data-testid="donate-lightning"
          onClick={() => setTipOpen(true)}
          style={{ justifyContent: "center" }}
        >
          <img src="/" alt="" className="inline-block h-4 w-4 align-middle" /> tip in sats (lightning)
        </button>

        {/* On-chain BTC */}
        <button
          type="button"
          className="xs-btn"
          data-testid="donate-btc"
          onClick={() => copy(BTC_ADDRESS, "btc")}
          style={{ justifyContent: "center" }}
        >
          ₿ {copied === "btc" ? "copied!" : "bitcoin on-chain"}
        </button>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 10,
          marginTop: 12,
          fontSize: "0.75em",
          color: "rgba(255, 222, 22, 0.75)",
          fontFamily: "Courier New, monospace",
          wordBreak: "break-all",
        }}
      >
        <div>
          <div style={{ opacity: 0.7, fontFamily: "Tahoma, sans-serif" }}>lightning</div>
          <code>{LN_ADDRESS}</code>
        </div>
        <div>
          <div style={{ opacity: 0.7, fontFamily: "Tahoma, sans-serif" }}>
            btc on-chain (<a href={MEMPOOL_URL} target="_blank" rel="noreferrer">explorer ↗</a>)
          </div>
          <code>{BTC_ADDRESS}</code>
        </div>
      </div>
      <LightningTipModal open={tipOpen} onClose={() => setTipOpen(false)} />
    </section>
  );
}
